import script from "./MainBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./MainBanner.vue?vue&type=script&setup=true&lang=js"

import "./MainBanner.vue?vue&type=style&index=0&id=0c388a19&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c388a19"]])

export default __exports__